import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'

import create from 'zustand'

type ItemMode = 'new' | 'edit' | 'duplicate'

interface ItemDrawer {
  sequence: string
  productId: string
  isDrawerOpen: boolean
  selectedItem: any
  itemMode: ItemMode
  setItemMode: (itemMode: ItemMode) => void
  setIsDrawerOpen: (open: boolean) => void
  setProductId: (productId: string) => void
  setSequence: (sequence: string) => void
  setSelectedItem: (selectedItem: any) => void
  resetSelectedItem: () => void
}

const useStoreBase = create<ItemDrawer>()((set) => ({
  sequence: '0',
  productId: '',
  isDrawerOpen: false,
  selectedItem: {},
  itemMode: 'new',
  setItemMode: (itemMode: ItemMode) => set(() => ({ itemMode })),
  setIsDrawerOpen: (isDrawerOpen: boolean) => set(() => ({ isDrawerOpen })),
  setProductId: (productId: string) => set(() => ({ productId })),
  setSequence: (sequence: string) => set(() => ({ sequence })),
  setSelectedItem: (selectedItem: any) => set(() => ({ selectedItem })),
  resetSelectedItem: () => set(() => ({ selectedItem: {} }))
}))

export const useItemFormDrawerStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<ItemDrawer>
